import { useQuery } from "@tanstack/react-query";

export function useGetPolicyById({ callApiWithWorker, id, language, enabled }) {
  return useQuery({
    queryKey: ["policy", id, language],
    enabled: Boolean(enabled && id),
    queryFn: async () => {
      const res = await callApiWithWorker(
        `/policy-templates/${encodeURIComponent(id)}?language=${encodeURIComponent(language)}&include_details=true`,
        { method: "GET" },
      );

      return res;
    },
    staleTime: 30_000,
  });
}
